<template>
  <ob-admin-section
    :type="type"
    :xlsx="true"
    :relatedItems="relatedItems"
    @itemsSelected="_cbItemsSelected"
    @downloadActivity="downloadActivityReport">
    <template slot="section-title">Sectiune Utilizatori Aplicatie</template>
    <template slot="toolbar-title">Baza de date Utilizatori Aplicatie</template>
    <template slot="ob-row-expansion" slot-scope="{_id}">
      <ob-colectii-apl :_id="_id"></ob-colectii-apl>
    </template>

    <template slot="fab">
      <div class="ob-compute-fab">
        <v-tooltip left>
          <span slot="activator">
            <v-btn
              :disabled="!items.length"
              fab
              color="primary"
              @click="_cbDuplicate">
              <v-icon>mdi-content-duplicate</v-icon>
            </v-btn>
          </span>
          <span>Creeaza copii pentru elementele selectate ({{items.length}}).</span>
        </v-tooltip>
      </div>
    </template>
  </ob-admin-section>
</template>

<script>
import AdminSection from '@/components/AdminSection'
import ColectiiAPL from '@/components/ColectiiAPL'
import streamSaver from 'streamsaver'

export default {
  name: 'users',
  components: {
    'ob-admin-section': AdminSection,
    'ob-colectii-apl': ColectiiAPL
  },
  data: () => ({
    type: 'users',
    items: []
  }),
  computed: {
    relatedItems () {
      return this.$store.getters[`${this.type}/relatedItems`]
    },
    host () {
      return this.$store.getters.host
    },
    token () {
      return this.$store.getters['token']
    },
    user () {
      return this.$store.getters['user']
    }
  },
  methods: {
    _cbItemsSelected (items) {
      this.items = [...items]
    },
    _cbDuplicate () {
      this.items.forEach(item => {
        this.$store.dispatch('users/duplicateUser', item)
      })
    },
    downloadActivityReport (event) {
      if (event.type === this.type) {
        this.$store.commit(`${this.type}/setLoading`, true)
        if (this.host !== 'http://localhost:3333' && this.host !== 'http://http://10.194.250.173') {
          streamSaver.mitm = `${this.host}/mitm.html`
        }
        const fileStream = streamSaver.createWriteStream(`TUDs_Analytics_Activitate_${event.payload.username}.zip`)
        fetch(`${this.host}/rest-user-activity`, {
          method: 'post',
          headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': this.token
          }),
          body: JSON.stringify({ id: event.payload._id })
        })
          .then(res => {
            this.$store.commit(`${this.type}/setLoading`, false)
            // more optimized
            if (res.body.pipeTo) {
              return res.body.pipeTo(fileStream).then(() => console.log('done writing'))
            }

            const writer = fileStream.getWriter()
            const reader = res.body.getReader()
            const pump = () => reader.read().then(({ value, done }) => {
              if (done) {
                // close the stream so we stop writing
                writer.close()
                // this.$store.commit(`${this.type}/setLoading`, false)
                this.loading = false
              } else {
                // Write one chunk, then get the next one
                writer.write(value).then(pump)
              }
            })

            // Start the reader
            pump().then(() => {
              this.$store.commit(`${this.type}/setLoading`, false)
              console.log('Closed the stream, Done writing')
            })
          })
          .catch(err => {
            this.$store.commit(`${this.type}/setLoading`, false)
            console.log(err)
          })
      }
    }
  },
  created () {
    this.$store.dispatch(`${this.type}/setEventWatchers`)
    this.$store.dispatch(`${this.type}/fetchHeaders`)
    this.$store.dispatch(`${this.type}/fetchAllRelated`, null)
  }
}
</script>

<style>

</style>
